var render = function (_h,_vm) {var _c=_vm._c;return _c('p',{staticClass:"input-label"},[_vm._v(" "+_vm._s(_vm.props.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }